<!--div class="contend">
  <div class="buttonMenu" [matMenuTriggerFor]="menuUser" aria-label="Menú de usuario">
    <mat-icon>account_circle</mat-icon>
  </div>
  <mat-menu #menuUser="matMenu" class="user-menu">
    <div class="px-3 py-2">
      <p class="mb-1 fw-bold text-primary">
        <mat-icon class="me-1">person</mat-icon>{{ userData.username }}
      </p>
      <p class="mb-2 text-muted small">
        <mat-icon class="me-1">mail</mat-icon>{{ userData.username }}
      </p>
      <button mat-flat-button color="warn" class="button w-100" (click)="handlerLogout()">
        <mat-icon class="me-1">logout</mat-icon>
        Cerrar sesión
      </button>
    </div>
  </mat-menu>
</div-->

<div class="contend">
  <div 
    class="buttonMenu d-flex align-items-center" 
    [matMenuTriggerFor]="menuUser" 
    aria-label="Menú de usuario"
  >
    <mat-icon class="mat-icon-account">account_circle</mat-icon>
  </div>

  <mat-menu #menuUser="matMenu" class="user-menu">

    <div class="px-3 py-3 user-info">

      <!-- Avatar -->
      <div class="text-center mb-3">
        <mat-icon class="avatar-icon">account_circle</mat-icon>
      </div>

      <!-- Nombre -->
      <p class="mb-1 text-muted small d-flex align-items-center">
        <mat-icon class="me-1 small-icon">badge</mat-icon>
        {{ userData.fullName }}
      </p>

      <!-- Correo -->
      <p class="mb-1 text-muted small d-flex align-items-center">
        <mat-icon class="me-1 small-icon">mail</mat-icon>
        {{ userData.username }}
      </p>

      <!-- Rol -->
      <p class="mb-1 text-muted small d-flex align-items-center">
        <mat-icon class="me-1 small-icon">security</mat-icon>
        {{ groupsDescription.join(', ') }}
      </p>

      <!-- Empresa -->
      <p class="mb-3 text-muted small d-flex align-items-center">
        <mat-icon class="me-1 small-icon">business</mat-icon>
        {{ userData.companyName }}
      </p>

      <!-- Botón cerrar sesión -->
      <button 
        mat-flat-button 
        color="warn" 
        class="button w-100 mt-2" 
        (click)="handlerLogout()"
      >
        <mat-icon class="me-1">logout</mat-icon>
        Cerrar sesión
      </button>

    </div>

  </mat-menu>
</div>
